import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'
import { resolve } from 'core-js/fn/promise'

const state = {}

const actions = {
    // 获取试卷管理列表
    getPaperList({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['questionBank:testPaper:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/question_bank/test_paper`,
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 试卷详情
    getPaperPreview({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['questionBank:testPaper:info']).then(res => {
                if (res) {
                    request({
                        url: `/api/question_bank/test_paper/${data}`,
                        // data: { id: data }
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 试卷详情
    getPaperModlePreview({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/test_paper/${data.id}/section/${data.mId}`,
                // data: { id: data }
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 创建试卷
    postPaper({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/test_paper`,
                method: "post",
                data: {name:data}
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 复制试卷
    copyPaper({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/test_paper/${data.id}/copy`,
                method: "post",
                data: {name:data.name}
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取所有题目
    getAllQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/question`,
                params: data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 编辑试卷
    putPaper({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/test_paper/${data.id}`,
                method: "put",
                data: JSON.stringify(data)
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 删除试卷
    deletePaper({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/question_bank/test_paper/${data}`,
                method: "delete",
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取试卷编辑自动保存信息
    getExamPaperAutoSave({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:answer:search']).then(res => {
                if (res) {
                    request({
                        url: `/api/question_bank/test_paper/${data}/temp`,
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 提交试卷编辑自动保存信息
    postExamPaperAutoSave({dispatch},data){
        return new Promise((resolve)=>{
            judgePermissions(['arrangement:answer:save']).then(res => {
                if (res) {
                    request({
                        url: `/api/question_bank/test_paper/${data.id}/temp`,
                        method: "post",
                        data: JSON.stringify(data)
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve()
                }
            })
        })
    },

    // 查询当前考生考试信息
    getExamCurrent({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/examinee/current`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 查询当前考生姓名
    getExamCurrentName({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/examinee/current/name`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取考试试卷
    getExamPaperById({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/test_paper/${data}/exam`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取考试试卷
    getExamPaper({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/test_paper/exam`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 保存考试试卷答案
    postExamPaperAnswer({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/exam`,
                method: "post",
                data:data
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 交卷
    endExam({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/arrangement/examinee/exam/end`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },
}

export default {
    state,
    actions
}